import React from "react";
import {getNameById} from "../utils/Utils";


export function IDMapFormatter(cellContent, row, rowIndex, {array}) {
    const id = parseInt(cellContent, 10);
    return (
        <span className={'text-info fs-7'}>{getNameById(id, array)}</span>
    );
}
